<template>
  <li class="library-card">
    <a :href="getLibraryDetailUrl(movie)" v-if="getLibraryDetailUrl(movie)">
      <div class="thumb">
        <img v-if="movie.icon_url" :src="movie.icon_url" :alt="movie.title" />
        <img v-else :src="commonImg('library/no_thum.jpg')" alt="aukana">
      </div>
      <div class="detail">
        <div class="credit">
          <credit-box v-bind:movie="movie"></credit-box>
        </div>
        <p class="title">{{ movie.title }}</p>
        <!-- ↓高さ揃えのため -->
        <div class="library-no-info"></div>
      </div>
    </a>
    <div v-else>
      <div class="thumb">
        <img v-if="movie.icon_url" :src="movie.icon_url" :alt="movie.title" />
        <img v-else :src="commonImg('library/no_thum.jpg')" alt="aukana">
      </div>
      <div class="detail">
        <div class="credit">
          <credit-box v-bind:movie="movie"></credit-box>
        </div>
        <p class="title">{{ movie.title }}</p>
        <div class="library-no-info">
          <img :src="pcImg('common/no_info/s.png')" class="lazy full is-pc">
          <img :src="spImg('common/no_info/s.png')" class="lazy full is-sp">
        </div>
      </div>
    </div>

  </li>
</template>

<script>
import CreditBox from './CreditBox'
import LibraryMixin from '../../mixin/Library'
import Mixin from '../../mixin/Mixin'

export default {
  name: 'LibraryCard',
  components: {
    CreditBox
  },
  props: ['movie'],
  mixins: [LibraryMixin, Mixin]
}
</script>

<style scoped lang="scss">
.library-card {
  width: 128px;
  @media screen and  (max-width: 600px) {
    width: 96px;
    &:first-of-type,
    &:last-of-type {
      margin-left: 14px;
    }
  }
  * {box-sizing: border-box; }
  a:hover { text-decoration: none; }
  .thumb {
    position: relative;
    width: 100%;
    height: 128px;
    @media screen and  (max-width: 600px) {
      height: 96px;
    }
    background-color: #f4f4fa;
    img {
      position: absolute;
      top: 50%;
      left: 50%;
      width: auto;
      max-width: 100%;
      max-height: 100%;
      transform: translate(-50%,-50%);
    }
  }
  .detail {
    min-height: 104px;
    padding: 4px 8px 8px;
    border: 1px solid #f4f4fa;
    border-top: none;
    .credit { min-height: 20px; }
    .credit-box {
      margin: 0;
      color: #b8b8b8;
      font-size: 1.0rem;
      text-align: center;
      white-space: normal;
    }
    .amazon-af-link {
      width: 88px;
      height: 20px;
      margin: 0 auto;
      border: 1px solid #757de0;
      border-radius: 4px;
      font-size: 1.1rem;
      font-weight: bold;
      text-align: center;
      line-height: 18px;
      box-sizing: border-box;
    }
    .title {
      min-height: 30px;
      margin-top: 8px;
      color: #333;
      font-size: 1.2rem;
      font-weight: bold;
      white-space: normal;
      // 2行で3点リーダー
      overflow: hidden;
      word-break: break-all;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      @media screen and  (max-width: 600px) {
        min-height: 44px;
        font-size: 1.1rem;
        -webkit-line-clamp: 3;
      }
    }
    .library-no-info {
      margin-top: 8px;
      min-height: 25px;
      .is-pc { display: block; }
      .is-sp { display: none }
      @media screen and  (max-width: 600px) {
        .is-pc { display: none; }
        .is-sp { display: block }
      }
    }
  }
}
</style>